module.exports = __webpack_public_path__ + "static/media/fly0214.fafd72e1.webp";